var _rect, _rect2, _rect3, _rect4, _rect5, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 336,
    viewBox: "0 0 104 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.390977,
    y: 0.872179,
    width: 75.0677,
    height: 96.1476,
    rx: 5.86466,
    fill: "url(#paint0_linear_1000_2651)",
    stroke: "url(#paint1_linear_1000_2651)",
    strokeWidth: 0.781955
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4211,
    y: 15.3333,
    width: 45.3534,
    height: 4.69014,
    rx: 2.34507,
    fill: "white",
    fillOpacity: 0.21
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 16.4211,
    y: 29.4037,
    width: 45.3534,
    height: 4.69014,
    rx: 2.34507,
    fill: "white",
    fillOpacity: 0.21
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16.4211,
    y: 43.4742,
    width: 45.3534,
    height: 4.69014,
    rx: 2.34507,
    fill: "white",
    fillOpacity: 0.21
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 16.4211,
    y: 57.5446,
    width: 45.3534,
    height: 4.69014,
    rx: 2.34507,
    fill: "white",
    fillOpacity: 0.21
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_1000_2651)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3985 80.5719C56.3985 71.3631 63.8664 63.8966 73.0802 63.8966C82.294 63.8966 89.7619 71.3631 89.7619 80.5719C89.7619 85.0651 87.984 89.1435 85.0928 92.1422C85.0117 92.2045 84.9337 92.2727 84.8594 92.347C84.7855 92.4209 84.7176 92.4985 84.6556 92.5793C81.656 95.4695 77.5759 97.2471 73.0802 97.2471C63.8664 97.2471 56.3985 89.7806 56.3985 80.5719ZM86.444 97.2481C82.784 100.183 78.1371 101.939 73.0802 101.939C61.2767 101.939 51.7068 92.3733 51.7068 80.5719C51.7068 68.7704 61.2767 59.2049 73.0802 59.2049C84.8837 59.2049 94.4537 68.7704 94.4537 80.5719C94.4537 85.6272 92.6976 90.2723 89.762 93.931L98.5232 102.689C99.4395 103.605 99.4397 105.09 98.5238 106.007C97.6078 106.923 96.1225 106.923 95.2062 106.007L86.444 97.2481Z",
    fill: "white",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_1000_2651",
    x: 36.0677,
    y: 43.5658,
    width: 78.7821,
    height: 78.7675,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.81955
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1000_2651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1000_2651",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.781955,
    dy: 1.56391
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.781955
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.39 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1000_2651"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1000_2651",
    x1: 37.9248,
    y1: 0.481201,
    x2: 37.9248,
    y2: 97.4108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1000_2651",
    x1: 37.9248,
    y1: 0.481201,
    x2: 37.9248,
    y2: 97.4108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTable);
export default __webpack_public_path__ + "static/media/emptyTable.2cece3eb071e71dcf4354632107ccc6a.svg";
export { ForwardRef as ReactComponent };